import './outside-promo-page.scss'

require.context('./static', true, /\.jpg|png|svg|webp$/)
